function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPadlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 4.978 6.35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M73.135 158.354v-1.353a1.787 1.787 0 0 0-1.785-1.776c-.983 0-1.779.794-1.786 1.776v1.353a.94.94 0 0 0-.705.91v1.372c0 .519.42.939.939.939h3.1c.519 0 .94-.42.94-.939v-1.373a.936.936 0 0 0-.703-.909m-2.877-1.353.001.005a1.095 1.095 0 0 1 1.09-1.085c.597 0 1.087.486 1.09 1.085l.002-.005v1.323h-2.183z",
    style: {
      strokeWidth: 0.264583
    },
    transform: "translate(-68.86 -155.225)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadlock);
export default __webpack_public_path__ + "static/media/padlock.0039ee3276792aa1c47bf548b1ab61c6.svg";
export { ForwardRef as ReactComponent };